<section class="cmn-innerpage-wrapper invoice-details">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>
    <button class="cmn-add-btn" (click)="navigateTo('invoice/invoice-new')" *ngIf="canCreateInvoice$ | async">
      <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> New Invoice
    </button>

    <!-- Filter -->
  </div>
  <div class="sub-head">
    <ul>
      <li class="main">All Invoices</li>
      <li
        *ngIf="isEditableStatus() && (canEditInvoice$ | async)"
        class="edit"
        (click)="navigateToEditPage()"
      >
        <img src="assets/images/icons/icon-edit-accounts.svg" alt="Edit" />
        Edit
      </li>

      <li *ngIf="isEditableStatus() && (canCancelInvoice$ | async)" class="delete" (click)="onRemoveInvoice()">
        <img src="assets/images/icons/icon-delete-li.svg" alt="Delete" />
        Cancel
      </li>

      <li *ngIf="isPdfStatus()" class="edit" (click)="onViewDocument()">
        <img src="assets/images/icons/icon-pdf.svg" alt="PDF" />
        PDF
      </li>

    </ul>

    <div class="mat-menu-wrapper" *ngIf="canSendInvoice$ | async">
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Example icon-button with a menu"
        *ngIf="invoiceData?.invoiceStatus === 'Approved'"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="markAsSent()">
          <span>Mark as Sent</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div class="manual-journal-details-tab-wrapper">
    <div class="tab-left">
      <div class="tab-box-main-wrapper">
        <button
          *ngFor="let invoice of allInvoices; let i = index"
          class="tab-custom-button"
          [class.active]="selectedTabIndex === i"
          (click)="selectTab(i)"
        >
          <div class="inn-box">
            <h2>
              {{
                invoice?.customerData?.firstName +
                  " " +
                  invoice?.customerData?.lastName
              }}
            </h2>
            <h3>{{ invoice?.invoiceNo }}</h3>
          </div>
          <div class="inn-box">
            <h6>{{ invoice?.invoiceDate | date : "dd MMM yyyy" }}</h6>
            <h5>{{ invoice?.invoiceStatus }}</h5>
          </div>
          <div class="inn-box">
            <h4 class="grey">{{ invoice?.orderData?.orderCode }}</h4>
          </div>
        </button>
      </div>
    </div>
    <div class="manual-journal-details-content-wrapper">
      <div *ngIf="invoiceData">
        <div class="chart-tab-content">
          <div class="tab-main-container">
            <div class="tab-inner">
              <div class="note-header">
                <div class="journal-details">
                  <div class="right-set">
                    <h2>TAX INVOICE</h2>
                    <h3>{{ invoiceData?.orderData?.orderCode }}</h3>
                    <div class="details-box">
                      <h4>Invoice No</h4>
                      <h5>:</h5>
                      <h6 class="invoice-detail-content">
                        {{ invoiceData?.invoiceNo }}
                      </h6>
                    </div>
                    <div class="details-box">
                      <h4>Invoice Date</h4>
                      <h5>:</h5>
                      <h6  class="invoice-detail-content">
                        {{ invoiceData?.invoiceDate | date : "dd MMM yyyy" }}
                      </h6>
                    </div>
                    <div class="details-box">
                      <h4>Due Date</h4>
                      <h5>:</h5>
                      <h6  class="invoice-detail-content">
                        {{ invoiceData?.dueDate | date : "dd MMM yyyy" }}
                      </h6>
                    </div>
                  </div>
                </div>

                <div class="left-set">
                  <div>
                    <h4>Bill To:</h4>
                    <h3>
                      <span>{{
                        invoiceData?.customerData?.firstName +
                          " " +
                          invoiceData?.customerData?.lastName
                      }}</span>
                    </h3>
                    <h3>{{ invoiceData?.customerData?.address }}</h3>
                    <h3>{{ invoiceData?.customerData?.city }}</h3>
                    <h3>{{ invoiceData?.customerData?.state }}</h3>
                    <h3>{{ invoiceData?.customerData?.country }}</h3>
                    <h3>{{ invoiceData?.customerData?.zipCode }}</h3>
                    <h3>Email: {{ invoiceData?.customerData?.email }}</h3>
                  </div>
                  <div>
                    <h4>Ship To:</h4>
                    <h3>
                      <span>{{
                        invoiceData?.customerData?.firstName +
                          " " +
                          invoiceData?.customerData?.lastName
                      }}</span>
                    </h3>
                    <h3>{{ invoiceData?.customerData?.address }}</h3>
                    <h3>{{ invoiceData?.customerData?.city }}</h3>
                    <h3>{{ invoiceData?.customerData?.state }}</h3>
                    <h3>{{ invoiceData?.customerData?.country }}</h3>
                    <h3>{{ invoiceData?.customerData?.zipCode }}</h3>
                    <h3>Email: {{ invoiceData?.customerData?.email }}</h3>
                  </div>
                </div>
              </div>
              <div class="crdit-note-page-table">
                <table>
                  <tr>
                    <th>Sl No</th>
                    <th>Item Name</th>
                    <th>Description</th>
                    <th>Quantity</th>
                    <th>Unit price</th>
                    <th>Sub total</th>
                    <th>VAT(5%)</th>
                    <th>Amount</th>
                  </tr>
                  <tr
                    *ngFor="
                      let item of invoiceData?.invoiceItems;
                      let i = index
                    "
                  >
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.itemName }}</td>
                    <td>{{ item.description }}</td>
                    <td>{{ item.quantity || "--" }}</td>
                    <td>
                      AED
                      {{
                        item.rate != null
                          ? (item.rate | number : "1.2-2")
                          : "--"
                      }}
                    </td>
                    <td>
                      AED
                      {{
                        item.subTotal != null
                          ? (item.subTotal | number : "1.2-2")
                          : "--"
                      }}
                    </td>
                    <td>
                      AED
                      {{
                        item.tax != null ? (item.tax | number : "1.2-2") : "--"
                      }}
                    </td>
                    <td>
                      AED
                      {{
                        item.totalAmount != null
                          ? (item.totalAmount | number : "1.2-2")
                          : "--"
                      }}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="page-footer-content">
                <div class="left-set"></div>
                <div class="right-set">
                  <div class="details-box">
                    <h4>Sub Total</h4>
                    <h5>:</h5>
                    <h6>
                      AED {{ invoiceData?.subTotal | number : "1.2-2" }}
                    </h6>
                  </div>
                  <div class="details-box">
                    <h4>VAT Amount (5%)</h4>
                    <h5>:</h5>
                    <h6>AED {{ invoiceData?.tax | number : "1.2-2" }}</h6>
                  </div>
                  <div class="details-box">
                    <h4>Discount(-)</h4>
                    <h5>:</h5>
                    <h6>AED {{ invoiceData?.discount | number : "1.2-2" }}</h6>
                  </div>
                  <div class="details-box">
                    <h4>Total Amount</h4>
                    <h5>:</h5>
                    <h6>
                      AED {{ invoiceData?.totalAmount | number : "1.2-2" }}
                    </h6>
                  </div>
                </div>
              </div>

              <!-- <span
                class="published-note"
                *ngIf="invoiceData?.status === 'Draft'"
                ><img src="assets/images/img-draft.svg" alt="canceled"
              /></span>
              <span
                class="published-note"
                *ngIf="invoiceData?.status === 'Paid'"
                ><img src="assets/images/img-closed.svg" alt="Draft"
              /></span>
              <span
                class="published-note"
                *ngIf="invoiceData?.status === 'Open'"
                ><img src="assets/images/img-open.svg" alt="Draft"
              /></span>
              <span
                class="published-note"
                *ngIf="invoiceData?.status === 'DECLINED'"
                ><img src="assets/images/img-cancelled.svg" alt="Draft"
              /></span>
              <span
                class="published-note"
                *ngIf="invoiceData?.status === 'Sent'"
                ><img src="assets/images/img-issued.svg" alt="Draft"
              /></span>
              <span
                class="published-note"
                *ngIf="invoiceData?.status === 'Cancelled'"
                ><img src="assets/images/img-cancelled.svg" alt="Cancel"
              /></span> -->

              <p
                *ngIf="
                  invoiceData?.invoiceStatus === 'Approved' ||
                  invoiceData?.invoiceStatus === 'Rejected' ||
                  invoiceData?.invoiceStatus === 'Sent'
                "
                class="approvedBy"
              >
                {{ invoiceData?.IsApproved ? "Approved By" : "Rejected By" }} :
                {{ invoiceData?.approvedOrRejectedBy }}
              </p>
              <p class="signature">Authorized Signature <span></span></p>
            </div>
          </div>

          <div
            *ngIf="invoiceData?.invoiceStatus === 'Pending' && (canApproveRejectInvoice$ | async)"
            class="invoice-details-footer-wrapper"
          >
            <div class="submit-btn-wrapper">
              <button
                class="cmn-next-btn"
                type="button"
                (click)="handleApproval(true, invoiceData.id)"
              >
                Approve
              </button>
              <button
                class="cmn-next-btn"
                type="button"
                (click)="handleApproval(false, invoiceData.id)"
              >
                Reject
              </button>
            </div>
          </div>
          <div
            *ngIf="
              invoiceData.invoiceStatus === 'Approved' ||
              invoiceData.invoiceStatus === 'Sent'
            "
            class="credit-note-footer-table-wrapper"
          >
            <table>
              <tr class="title">
                <td>Journal</td>
              </tr>

              <tr>
                <td>
                  Date:
                  {{
                    invoiceData?.journalData?.postedAt | date : "dd MMM yyyy"
                  }}
                </td>
              </tr>
              <tr>
                <td>Journal No: {{ invoiceData?.journalData?.journalNo }}</td>
              </tr>
              <tr>
                <td>Account</td>
                <td>Debit</td>
                <td>Credit</td>
              </tr>
              <tr
                class="bold"
                *ngFor="
                  let entry of invoiceData?.journalData?.journalEntries || []
                "
              >
                <td>
                  {{ entry?.accountData?.accountName }}
                </td>
                <td>AED {{ entry.debit | number : "1.2-2" }}</td>
                <td>AED {{ entry.credit | number : "1.2-2" }}</td>
              </tr>
              <tr class="bold">
                <td></td>
                <td>AED {{ getDebitTotal() | number : "1.2-2" }}</td>
                <td>AED {{ getCreditTotal() | number : "1.2-2" }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
